<div class="w-full flex justify-center">
  <div class="max-w-md w-full mx-auto">
    <!-- Header -->
    <div class="text-center mb-8">
      <h1 class="text-4xl font-bold text-base-content">Verify Your Identity</h1>
      <p class="text-base-content/70 mt-2">
        Complete the verification process to confirm your identity
      </p>
    </div>

    <div class="daisy-card bg-base-100 shadow-xl">
      <div class="daisy-card-body items-center text-center">
        <p class="text-base-content/70 mb-6">
          We are sending an OTP to validate your mobile number or email address
        </p>

        <!-- Resend Timer/Button -->
        <div class="mb-4">
          @if (resendEnable) {
          <button (click)="sendCode()" class="daisy-btn daisy-btn-outline">
            Resend Code
          </button>
          } @else {
          <p class="text-base-content/70">
            Resend available in
            {{ timeRemaining$ | async | date: 'mm:ss':'UTC' }}
          </p>
          }
        </div>

        <!-- Error Alert -->
        @if (otpError) {
        <div class="daisy-alert daisy-alert-error mb-4 justify-center">
          <i class="fa-solid fa-circle-exclamation"></i>
          <span>{{ otpError }}</span>
        </div>
        }

        <!-- OTP Form -->
        <form class="space-y-6 w-full" [formGroup]="otpForm">
          <div class="daisy-form-control w-full flex items-center justify-center">
            <black-otp formControlName="otp"></black-otp>
          </div>

          <!-- Submit Button -->
          <button
            [disabled]="otpLength < 6"
            (click)="submit()"
            class="daisy-btn daisy-btn-primary w-full max-w-xs"
          >
            Verify
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

